import { render, staticRenderFns } from "./WabaSupsisAdAccountLinked.vue?vue&type=template&id=46f728a5&scoped=true"
import script from "./WabaSupsisAdAccountLinked.vue?vue&type=script&lang=js"
export * from "./WabaSupsisAdAccountLinked.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisAdAccountLinked.vue?vue&type=style&index=0&id=46f728a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f728a5",
  null
  
)

export default component.exports